module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate/collegiate-designs/designs-8-3a095cb9f218a98b4b52073ab33121fc.jpg";